import {
    faDownload,
    faMinus,
    faMinusCircle,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription, ExpandRowProps } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import Table from "../../../../Components/Table";
import {
    ExecutarNegativacaoClienteSerasaController,
    ListarClientesParcelasAtrasoSerasaController,
    // ListarClientesParcelasAtrasoSerasaExportarExcelController,
    ListarParcelasAtrasoPorClienteSerasaController,
    ListarParcelasAtrasoPorClienteSerasaExportarExcelController,
} from "../../../../Controllers/Serasa/Negativar";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import usePaginationFilter from "../../../../hooks/usePaginationFilter";
import {
    IClientesParcelaAtraso,
    IListagemParcelasClienteSerasa,
    IListarClientesParcelasAtraso,
    IListarParcelasAtrasoPorCliente,
    ILstParcelasAtrasoPorClienteBody,
} from "../../../../Interfaces/Cobranca/Serasa/Negativar";

import { formatMoneyReais } from "../../../../Tools/FormatTools";
import FiltroNegativar from "./FiltroNegativar";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
// import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import saveAs from "file-saver";
import { FormatterCPF } from "../../../../Validations/InputMasks";

export default function Negativar() {
    const [parcelasNegativar, setParcelasNegativar] =
        useState<IListarParcelasAtrasoPorCliente>();
    const [resp, setResp] = useState<IListarParcelasAtrasoPorCliente>();
    const [respClientes, setRespClientes] =
        useState<IListarClientesParcelasAtraso>();
    const [limparFiltros, setLimparFiltros] = useState(false);
    const [fecharParcelas, setFecharParcelas] = useState(false);
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    const [dsCliente, setDsCliente] = useState<string>("");
    const [idChaveErp, setIdChaveErp] = useState<string>("");
    const [dsTipoCliente, setDsTipoCliente] = useState<string>("");

    const [totalPaginasClientes, setTotalPaginasClientes] = useState<number>(
        respClientes ? respClientes.NR_PAGINA : 1
    );

    const [PageFilterClientes, setPageFilterClientes] = useState<
        number | undefined
    >();

    const FILTRO_GESTAO_A_NEGATIVAR = sessionStorage.getItem(
        "FILTRO_GESTAO_A_NEGATIVAR"
    );

    const filtroInicial = {
        DS_NOME: "",
        ID_CHAVE_ERP: "",
        DS_STATUS: "",
        ID_EMPREENDIMENTO: [],
        NR_CPF_CNPJ: "",
        NR_VENDA: "",
        DS_TIPO_CLIENTE: "",
    };

    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<ILstParcelasAtrasoPorClienteBody>({
            page: 1,
            filter: FILTRO_GESTAO_A_NEGATIVAR
                ? JSON.parse(FILTRO_GESTAO_A_NEGATIVAR)
                : filtroInicial,
        });

    const totalPaginasRowNegativar = resp ? resp?.NR_PAGINAS : 1;
    const {
        execute: ListarParcelasAtrasoPorClienteSerasaExportarExcel,
        loading: ListarParcelasAtrasoPorClienteSerasaExportarExcelLoading,
    } = useAsyncCallback(
        ListarParcelasAtrasoPorClienteSerasaExportarExcelController
    );

    const handleDateChange = (formData: ILstParcelasAtrasoPorClienteBody) => {
        const filterFormData = {
            DS_NOME: formData.DS_NOME,
            ID_CHAVE_ERP: formData.ID_CHAVE_ERP,
            DS_STATUS: formData.DS_STATUS,
            ID_EMPREENDIMENTO: formData.ID_EMPREENDIMENTO,
            NR_CPF_CNPJ: formData.NR_CPF_CNPJ,
            NR_VENDA: formData.NR_VENDA,
            DS_TIPO_CLIENTE: formData.DS_TIPO_CLIENTE,
        };
        if (
            !formData.DS_NOME &&
            !formData.ID_CHAVE_ERP &&
            !formData.DS_STATUS &&
            !formData.ID_EMPREENDIMENTO &&
            !formData.NR_CPF_CNPJ &&
            !formData.NR_VENDA &&
            !formData.DS_TIPO_CLIENTE
        ) {
            setPage(totalPaginasClientes);
        }
        setFecharParcelas(true);
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_GESTAO_A_NEGATIVAR",
            JSON.stringify(filterFormData)
        );
    };

    const columnsClienteParcelaNegativar: Array<
        ColumnDescription<IListagemParcelasClienteSerasa>
    > = [
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.ID_PARCELA",
            text: "ID Parcela",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "",
            text: "Cliente",
            align: "center",
            formatter: (c, row) => (
                <>
                    {row.DS_TIPO_CONTATO
                        ? row.parcelasClienteSerasaDTO.DS_NOME_CONTATO
                        : row.parcelasClienteSerasaDTO.DS_NOME}
                </>
            ),
        },
        {
            headerAlign: "center",
            dataField: "",
            text: "Tipo Cliente",
            align: "center",
            formatter: (c, row) => (
                <>
                    {row.DS_TIPO_CONTATO ? row.DS_TIPO_CONTATO : "Proprietário"}
                </>
            ),
        },
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.DS_TIPO_PARCELA",
            text: "Tipo Parcela",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.VL_PARCELA",
            text: "Valor da Parcela",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
        },
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.VL_JUROS_ATRASO",
            text: "Valor Juros Atraso",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
        },
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.VL_MULTA_ATRASO",
            text: "Valor Multa Atraso",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
        },
        {
            headerAlign: "center",
            dataField: "",
            text: "Total",
            align: "center",
            formatter: (c, row) =>
                formatMoneyReais(
                    (row.parcelasClienteSerasaDTO?.VL_PARCELA ?? 0) +
                        (row.parcelasClienteSerasaDTO?.VL_JUROS_ATRASO ?? 0) +
                        (row.parcelasClienteSerasaDTO?.VL_MULTA_ATRASO ?? 0)
                ),
        },
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.DT_VENCIMENTO",
            text: "Dt. vencimento",
            align: "center",
            formatter: (c) => (
                <div className="py-5">
                    {" "}
                    {c ? new Date(c).toLocaleDateString() : "-"}
                </div>
            ),
        },
        {
            headerAlign: "center",
            dataField: "parcelasClienteSerasaDTO.DS_STATUS_SERASA",
            text: "Status Negativação",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "",
            text: "",
            align: "center",
            headerFormatter: () => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            Exportar Excel
                        </Tooltip>
                    }
                >
                    <button
                        className="btn btn-icon btn-outline-success"
                        onClick={() => {
                            ListarParcelasAtrasoPorClienteSerasaExportarExcel(
                                0,
                                10,
                                {
                                    DS_NOME: filter?.DS_NOME
                                        ? filter?.DS_NOME
                                        : dsCliente,
                                    ID_CHAVE_ERP: filter?.ID_CHAVE_ERP
                                        ? filter?.ID_CHAVE_ERP
                                        : idChaveErp,
                                    DS_STATUS: filter?.DS_STATUS ?? "",
                                },
                                true
                            ).then((res) => {
                                saveAs(
                                    new Blob([res], {
                                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    }),
                                    "Parcelas_Negativar"
                                );
                            });
                        }}
                    >
                        {ListarParcelasAtrasoPorClienteSerasaExportarExcelLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faDownload} />
                        )}
                    </button>
                </OverlayTrigger>
            ),
        },
    ];

    const expandRowNegativar: ExpandRowProps<IClientesParcelaAtraso> = {
        showExpandColumn: true,
        expandByColumnOnly: true,
        onlyOneExpanding: true,
        expandHeaderColumnRenderer: ({ isAnyExpands }) => {
            return <></>;
        },
        expandColumnRenderer: ({ expanded }) => {
            if (expanded) {
                return <FontAwesomeIcon icon={faMinus} />;
            }
            return <FontAwesomeIcon icon={faPlus} />;
        },
        renderer: (row, rowIndex) => (
            <>
                <Table
                    headerClasses="bg-white"
                    columns={columnsClienteParcelaNegativar}
                    data={resp?.PARCELAS ?? []}
                    tableView={{
                        columns: columnsClienteParcelaNegativar,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    remote={{ pagination: true }}
                    totalPages={totalPaginasRowNegativar}
                    // loading={!resp || loadingParcelas}
                    keyField="ID_CAPYS"
                    classes="v-middle-cells"
                    noDataIndication={
                        <div className="text-center text-black-50">
                            Nenhuma parcela a Negativar
                        </div>
                    }
                    striped={true}
                    bordered={true}
                    noSearch
                    selectRow={{
                        mode: "checkbox",
                        clickToSelect: true,
                        selected: parcelasNegativar?.PARCELAS?.map(
                            (parcela) => parcela?.ID_CAPYS || 0
                        ),
                        nonSelectable: resp?.PARCELAS?.filter(
                            (parcela) =>
                                parcela.parcelasClienteSerasaDTO
                                    ?.DS_STATUS_SERASA === "Negativado" ||
                                parcela.parcelasClienteSerasaDTO
                                    ?.DS_STATUS_SERASA ===
                                    "Aguardando Negativação" ||
                                parcela?.parcelasClienteSerasaDTO
                                    ?.DS_STATUS_SERASA ===
                                    "Em Fila de Negativação"
                        ).map((parcela) => parcela?.ID_CAPYS || 0),
                        onSelect: (row, isSelect, rowIndex, e) => {
                            if (isSelect)
                                setParcelasNegativar((parcelaNegativar) => {
                                    return {
                                        NR_PAGINAS: 1,
                                        PARCELAS: [
                                            ...(parcelaNegativar?.PARCELAS ??
                                                []),
                                            row,
                                        ],
                                    };
                                });
                            else
                                setParcelasNegativar((parcelaNegativar) => {
                                    return {
                                        NR_PAGINAS: 1,
                                        PARCELAS:
                                            parcelaNegativar?.PARCELAS?.filter(
                                                (parcela) =>
                                                    parcela?.ID_CAPYS !==
                                                    row?.ID_CAPYS
                                            ),
                                    };
                                });
                        },

                        onSelectAll: (isSelect, rows, e) => {
                            if (isSelect) {
                                // Selecionar todos
                                setParcelasNegativar((prevParcelas) => {
                                    return {
                                        NR_PAGINAS: 1,
                                        PARCELAS: [
                                            ...(prevParcelas?.PARCELAS || []),
                                            ...rows.filter(
                                                (row) =>
                                                    !prevParcelas?.PARCELAS?.some(
                                                        (parcela) =>
                                                            parcela?.ID_CAPYS ===
                                                            row?.ID_CAPYS
                                                    )
                                            ),
                                        ],
                                    };
                                });
                            } else {
                                setParcelasNegativar((prevParcelas) => {
                                    return {
                                        NR_PAGINAS: 1,
                                        PARCELAS:
                                            prevParcelas?.PARCELAS?.filter(
                                                (parcela) =>
                                                    !rows.some(
                                                        (row) =>
                                                            row?.ID_CAPYS ===
                                                            parcela?.ID_CAPYS
                                                    )
                                            ),
                                    };
                                });
                            }
                        },
                    }}
                />
            </>
        ),
        onExpand: async (row, isExpand) => {
            PageFilter.page = 1;
            const response =
                await ListarParcelasAtrasoPorClienteSerasaController(
                    PageFilter.page,
                    10,
                    {
                        ...filter,
                        DS_NOME: filter?.DS_NOME
                            ? filter?.DS_NOME
                            : row?.DS_CLIENTE ?? "",
                        ID_CHAVE_ERP: filter?.ID_CHAVE_ERP
                            ? filter?.ID_CHAVE_ERP
                            : row.ID_CHAVE_ERP,
                        DS_STATUS: filter?.DS_STATUS ?? "",
                        DS_TIPO_CLIENTE:
                            row.DS_TIPO_CLIENTE === "Proprietário"
                                ? true
                                : false,
                    }
                );

            const lstParcelas = response.PARCELAS?.map((value) => {
                return {
                    ...value,
                };
            });
            setDsTipoCliente(row.DS_TIPO_CLIENTE);
            setIdChaveErp(row?.ID_CHAVE_ERP ?? "");
            setDsCliente(row?.DS_CLIENTE ?? "");
            setResp({
                NR_PAGINAS: response.NR_PAGINAS,
                PARCELAS: lstParcelas?.map((lst) => ({
                    ...lst,
                    DS_TIPO_CONTATO: lst.DS_TIPO_CONTATO,
                    ID_CAPYS: lst.ID_CAPYS,
                })),
            });
        },
    };

    const columnsNegativar: Array<ColumnDescription<IClientesParcelaAtraso>> = [
        {
            headerAlign: "center",
            dataField: "ID_CHAVE_ERP",
            text: "ID_CHAVE_ERP",
            align: "center",
            formatter: (c) => <div className="py-5">{c ? c : "-"}</div>,
        },
        {
            headerAlign: "center",
            dataField: "DS_NOME",
            text: "Cliente",
            align: "center",
            formatter: (c) => <div className="py-5">{c ? c : "-"}</div>,
        },
        {
            headerAlign: "center",
            dataField: "NR_CPF",
            text: "CPF",
            align: "center",
            formatter: (c) => (
                <div className="py-5">{c ? FormatterCPF(c) : "-"}</div>
            ),
        },
        {
            headerAlign: "center",
            dataField: "DS_PRODUTO",
            text: "Unidade",
            align: "center",
            formatter: (c) => <div className="py-5">{c ? c : "-"}</div>,
        },
        {
            headerAlign: "center",
            dataField: "DS_TIPO_CLIENTE",
            text: "Tipo Cliente",
            align: "center",
            formatter: (c) => <div className="py-5">{c ? c : "-"}</div>,
        },
        {
            headerAlign: "center",
            dataField: "DT_VENDA",
            text: "Dt. da Venda",
            align: "center",
            formatter: (c) => (
                <div className="py-5">
                    {c ? new Date(c).toLocaleDateString() : "-"}
                </div>
            ),
        },
    ];

    const {
        execute: ExecutarNegativacaoClienteSerasa,
        loading: ExecutarNegativacaoClienteSerasaLoading,
    } = useAsyncCallback(ExecutarNegativacaoClienteSerasaController);

    const handleExecutarNegativacao = () => {
        ExecutarNegativacaoClienteSerasa(
            parcelasNegativar?.PARCELAS?.map((prcls) => ({
                ID_CHAVE_ERP:
                    prcls.parcelasClienteSerasaDTO?.ID_CHAVE_ERP ?? "",
                ID_CONTA: prcls.parcelasClienteSerasaDTO?.ID_CONTA ?? 0,
                ID_CONTATO: prcls.DS_TIPO_CONTATO
                    ? prcls.parcelasClienteSerasaDTO?.ID_CONTATO ?? 0
                    : 0,
            })) ?? []
        ).then((res) => {
            setParcelasNegativar({
                NR_PAGINAS: 1,
                PARCELAS: [],
            });
            ListarParcelasAtrasoPorClienteSerasaController(
                PageFilter.page,
                10,
                {
                    DS_NOME: filter?.DS_NOME ? filter?.DS_NOME : dsCliente,
                    ID_CHAVE_ERP: filter?.ID_CHAVE_ERP
                        ? filter?.ID_CHAVE_ERP
                        : idChaveErp,
                    DS_STATUS: filter?.DS_STATUS ?? "",
                    // DS_TIPO_CLIENTE:
                    //     dsTipoCliente === "Proprietário" ? true : false,
                }
            ).then((response) => {
                setResp({
                    NR_PAGINAS: 1,
                    PARCELAS: [],
                });
                const lstParcelas = response.PARCELAS?.map((value) => {
                    return {
                        ...value,
                    };
                });
                setResp({
                    NR_PAGINAS: response?.NR_PAGINAS,
                    PARCELAS: lstParcelas,
                });
            });
        });
    };

    const { loading: loadingParcelas } = useAsyncEffect(async () => {
        if (limparFiltros) {
            await ListarParcelasAtrasoPorClienteSerasaController(
                PageFilter.page,
                10,
                {
                    DS_NOME: filter?.DS_NOME ? filter?.DS_NOME : dsCliente,
                    ID_CHAVE_ERP: filter?.ID_CHAVE_ERP
                        ? filter?.ID_CHAVE_ERP
                        : idChaveErp,
                    DS_STATUS: filter?.DS_STATUS ?? "",
                    // DS_TIPO_CLIENTE:
                    //     dsTipoCliente === "Proprietário" ? true : false,
                }
            ).then((response) => {
                setResp({
                    NR_PAGINAS: 1,
                    PARCELAS: [],
                });
                const lstParcelas = response.PARCELAS?.map((value) => {
                    return {
                        ...value,
                    };
                });
                setResp({
                    NR_PAGINAS: response?.NR_PAGINAS,
                    PARCELAS: lstParcelas,
                });
            });

            await ListarClientesParcelasAtrasoSerasaController(
                PageFilterClientes ?? 1,
                {
                    DS_CLIENTE: filter?.DS_NOME ? filter?.DS_NOME : "",
                    ID_EMPREENDIMENTO: idEmpreendimento ? idEmpreendimento : "",
                    DS_TIPO_CLIENTE: filter?.DS_TIPO_CLIENTE
                        ? filter?.DS_TIPO_CLIENTE
                        : "",
                    ID_TIPO_CLIENTE:
                        filter?.DS_TIPO_CLIENTE === "Co-comprador"
                            ? 8
                            : filter?.DS_TIPO_CLIENTE === "Fiador"
                            ? 9
                            : filter?.DS_TIPO_CLIENTE === "Cliente"
                            ? 1
                            : 0,
                    DS_STATUS_PARCELA: filter?.DS_STATUS
                        ? filter?.DS_STATUS
                        : "",
                    NR_CPF_CNPJ: filter?.NR_CPF_CNPJ ? filter?.NR_CPF_CNPJ : "",
                    NR_VENDA: filter?.NR_VENDA ? filter?.NR_VENDA : "",
                    PAGINA: PageFilterClientes ?? 1,
                    QUANTIDADE: 10,
                }
            ).then((res) => {
                setTotalPaginasClientes(res.NR_PAGINA);
                const lstClientes = res.CLIENTE?.map((value) => {
                    return {
                        ...value,
                    };
                });
                setRespClientes({
                    ...res,
                    CLIENTE: lstClientes,
                    NR_PAGINA: res.NR_PAGINA,
                });
            });
            setPage(1);
            setLimparFiltros(false);
        }
    }, [PageFilterClientes, filter]);

    const { loading: loadingParcelasClientes } = useAsyncEffect(async () => {
        if (PageFilter.page > 0) {
            await ListarParcelasAtrasoPorClienteSerasaController(
                PageFilter.page,
                10,
                {
                    DS_NOME: filter?.DS_NOME ? filter?.DS_NOME : dsCliente,
                    ID_CHAVE_ERP: filter?.ID_CHAVE_ERP
                        ? filter?.ID_CHAVE_ERP
                        : idChaveErp,
                    DS_STATUS: filter?.DS_STATUS ?? "",
                    DS_TIPO_CLIENTE:
                        dsTipoCliente === "Proprietário" ? true : false,
                }
            ).then((response) => {
                setResp({
                    NR_PAGINAS: 1,
                    PARCELAS: [],
                });
                const lstParcelas = response.PARCELAS?.map((value) => {
                    return {
                        ...value,
                    };
                });
                setResp({
                    NR_PAGINAS: response?.NR_PAGINAS,
                    PARCELAS: lstParcelas,
                });
            });

            await ListarClientesParcelasAtrasoSerasaController(
                PageFilterClientes ?? 1,
                {
                    DS_CLIENTE: filter?.DS_NOME ? filter?.DS_NOME : "",
                    ID_EMPREENDIMENTO: idEmpreendimento,
                    DS_TIPO_CLIENTE: filter?.DS_TIPO_CLIENTE
                        ? filter?.DS_TIPO_CLIENTE
                        : "",
                    ID_TIPO_CLIENTE:
                        filter?.DS_TIPO_CLIENTE === "Co-comprador"
                            ? 8
                            : filter?.DS_TIPO_CLIENTE === "Fiador"
                            ? 9
                            : filter?.DS_TIPO_CLIENTE === "Cliente"
                            ? 1
                            : 0,
                    DS_STATUS_PARCELA: filter?.DS_STATUS
                        ? filter?.DS_STATUS
                        : "",
                    NR_CPF_CNPJ: filter?.NR_CPF_CNPJ ? filter?.NR_CPF_CNPJ : "",
                    NR_VENDA: filter?.NR_VENDA ? filter?.NR_VENDA : "",
                    PAGINA: PageFilterClientes ?? 1,
                    QUANTIDADE: 10,
                }
            ).then((res) => {
                setTotalPaginasClientes(res.NR_PAGINA);
                const lstClientes = res.CLIENTE?.map((value) => {
                    return {
                        ...value,
                    };
                });
                setRespClientes({
                    ...res,
                    CLIENTE: lstClientes,
                    NR_PAGINA: res.NR_PAGINA,
                });
            });
        }
    }, [PageFilter, PageFilterClientes, totalPaginasClientes]);

    useEffect(() => {
        if (!loadingParcelasClientes) {
            setFecharParcelas(false);
        }
    }, [loadingParcelasClientes]);
    return (
        <>
            <div className="card-body mt-n5 table-responsive">
                <div className="d-flex justify-content-end mb-3">
                    <button
                        className="btn btn-danger font-weight-bold "
                        onClick={() => {
                            Swal.fire({
                                title: `Deseja Negativar ${
                                    parcelasNegativar?.PARCELAS?.length ?? 0
                                } parcela${
                                    (parcelasNegativar?.PARCELAS?.length ?? 0) >
                                    1
                                        ? "s"
                                        : ""
                                }?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleExecutarNegativacao();
                                }
                            });
                        }}
                        disabled={
                            (parcelasNegativar?.PARCELAS?.length ?? 0) === 0 ||
                            ExecutarNegativacaoClienteSerasaLoading
                        }
                    >
                        {ExecutarNegativacaoClienteSerasaLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faMinusCircle} />
                        )}{" "}
                        Negativar
                    </button>
                </div>
                <OrSpinner loading={fecharParcelas} spinner="capys">
                    <Table
                        columns={columnsNegativar}
                        tableView={{
                            columns: columnsNegativar,
                            sizePerPage: 10,
                            cancelYScroll: true,
                            defaultStyle: true,
                            striped: true,
                        }}
                        data={respClientes?.CLIENTE ?? []}
                        remote={{ pagination: true }}
                        keyField="ID_CHAVE_ERP"
                        expandRow={expandRowNegativar}
                        loading={
                            !respClientes ||
                            loadingParcelas ||
                            loadingParcelasClientes
                        }
                        totalPages={totalPaginasClientes}
                        onTableChange={(type, newState) => {
                            setPageFilterClientes(newState.page);
                        }}
                        classes="v-middle-cells"
                        noDataIndication={
                            <div className="text-center text-black-50">
                                Nenhum cliente a Negativar
                            </div>
                        }
                        striped={true}
                        bordered={true}
                        noSearch
                    />
                </OrSpinner>
            </div>
            <FiltroNegativar
                FILTRO_GESTAO_A_NEGATIVAR={FILTRO_GESTAO_A_NEGATIVAR}
                handleDateChange={handleDateChange}
                filter={filter}
                filtroInicial={filtroInicial}
                setFilter={setFilter}
                setPage={setPage}
                setLimparFiltros={setLimparFiltros}
                setIdEmpreendimento={setIdEmpreendimento}
            />
            {/* <ExportExcel
                baixarExcelController={async () =>
                    ListarClientesParcelasAtrasoSerasaExportarExcelController(
                        0,
                        {
                            DS_CLIENTE: filter?.DS_NOME ? filter?.DS_NOME : "",
                            ID_EMPREENDIMENTO: idEmpreendimento
                                ? idEmpreendimento
                                : "",
                            DS_TIPO_CLIENTE: filter?.DS_TIPO_CLIENTE
                                ? filter?.DS_TIPO_CLIENTE
                                : "",
                            NR_CPF_CNPJ: filter?.NR_CPF_CNPJ
                                ? filter?.NR_CPF_CNPJ
                                : "",
                            NR_VENDA: filter?.NR_VENDA ? filter?.NR_VENDA : "",
                            PAGINA: 0,
                            QUANTIDADE: 10,
                        },
                        true
                    )
                }
                nomeArquivo={"Clientes_Negativar"}
            /> */}
        </>
    );
}
